import { render } from "./DatabaseIndex.vue?vue&type=template&id=299babec"
import script from "./DatabaseIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Database/DatabaseIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "299babec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('299babec', __exports__)) {
    api.reload('299babec', __exports__)
  }
  
  module.hot.accept("./DatabaseIndex.vue?vue&type=template&id=299babec", () => {
    api.rerender('299babec', render)
  })

}


export default __exports__